const authBaseUrl = String(import.meta.env.VITE_AUTH_BASE_URL ?? '').trim().replace(/\/$/, '');
const coreBaseUrl = String(import.meta.env.VITE_CORE_BASE_URL ?? '').trim().replace(/\/$/, '');
const googleClientId = String(import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '').trim();

/**
 * Runtime configuration for the agents app (Vite env).
 */
export const Configs = {
  authBaseUrl,
  /** coolture_core base URL (agentic platform APIs; unused until catalog/builder phases). */
  coreBaseUrl,
  loginApiPath: '/api/authentication/post/login/',
  logoutApiPath: '/api/authentication/post/logout/',
  /** Full login URL against coolture_auth */
  loginApiUrl: authBaseUrl ? `${authBaseUrl}/api/authentication/post/login/` : '',
  /** Full logout URL against coolture_auth */
  logoutApiUrl: authBaseUrl ? `${authBaseUrl}/api/authentication/post/logout/` : '',
  /** Google OAuth client ID (empty disables Google SSO UI). */
  googleClientId,
  /** Full SSO token exchange URL against coolture_auth */
  googleSsoApiUrl: authBaseUrl
    ? `${authBaseUrl}/api/authentication/post/authenticate/getKincodeToken`
    : '',
  /** True when Google OAuth client ID and auth base URL are configured. */
  googleSsoEnabled: Boolean(googleClientId && authBaseUrl),
  privateKey: String(import.meta.env.VITE_PRIVATE_KEY ?? '').trim(),
  unauthenticatedApiToken: String(import.meta.env.VITE_UNAUTHENTICATED_REQUESTS_API_TOKEN ?? '').trim(),
  /** Required by coolture_auth `POST /login/` (`X-Kincode-Client-Id`). */
  kincodeClientId: String(import.meta.env.VITE_KINCODE_CLIENT_ID ?? 'agents-web-local').trim(),
  enableMfaUi: String(import.meta.env.VITE_ENABLE_MFA_UI ?? 'false').toLowerCase() === 'true',
  isDev: import.meta.env.DEV,
} as const;
